<template>
  <v-main>
    <div class="content-scroller">
      <slot />
    </div>
  </v-main>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DefaultLayout',
})
</script>
